// extracted by mini-css-extract-plugin
module.exports = {"navigation-card":"CardsNonTouchScreen_navigation-card__gmgcU"};